import { hasChildren, type Work } from './api';

/** A work together with its depth in the tree (0 = section). */
export interface TreeNode {
  work: Work;
  level: number;
}

const CREATE_CHILD_LEVELS = [0, 1];
const DRAGGABLE_LEVELS = [1, 2];
const DROP_TARGET_LEVELS = [0, 1];
const SECTION_LEVEL = 0;

export const canCreateChild = (node: TreeNode) => CREATE_CHILD_LEVELS.includes(node.level);

export const isDraggable = (node: TreeNode) => DRAGGABLE_LEVELS.includes(node.level);

/** Dropping on `target` makes `source` its child; nodes that own children may only move under a section. */
export const canDropOn = (source: TreeNode, target: TreeNode) =>
  source.work.id !== target.work.id &&
  source.work.parent_id !== target.work.id &&
  DROP_TARGET_LEVELS.includes(target.level) &&
  (!hasChildren(source.work) || target.level === SECTION_LEVEL);
